// WidgetContext.js
import { createContext, useContext, useState } from 'react';

const WidgetContext = createContext();

export const WidgetProvider = ({ children }) => {
  const [hasUnsavedChanges, setHasUnsavedChanges] = useState(false);

  const [updateFn, setUpdateFn] = useState(null);

  return (
    <WidgetContext.Provider
      value={{
        hasUnsavedChanges,
        setHasUnsavedChanges,
        updateFn,
        setUpdateFn,
      }}
    >
      {children}
    </WidgetContext.Provider>
  );
};

export const useWidgetContext = () => useContext(WidgetContext);
